export default __webpack_public_path__ + "static/media/empty-state-rest.a648f078.svg";